module.exports = __webpack_public_path__ + "img/cinema1.c26d18ac.jpg";